import {type ExpressionElement} from '@packages/systems/wfdl-ast';
import {namesEqual, Qualified, qualify} from '@packages/systems/wfdl-Qualified';
import {isBoxSection} from './isBoxSection';
import {Component, Plugins} from '@packages/systems/wfdl';

const sectionType: Qualified<Component.ComponentName> = qualify(
  Plugins.name('Layout'),
  Component.name('Section')
);

// Classification trusts the persisted tag: a migrated Box with tag=section is a
// Section wherever it is read (matching DevLink export).
export function isSection(element: ExpressionElement): boolean {
  return namesEqual(element.type, sectionType) || isBoxSection(element);
}
